"use strict";

angular.module("core")
.directive("inviteToRegister", function(
    $rootScope, $http, gettextCatalog, FlashBag, EmailInputModalService, InviteToRegisterService, UserService
) {
    return {
        restrict: "A",
        scope: {
            customerId: "<?",
            initOrderConfirmationWatch: "<?"
        },
        bindToController: true,
        link: function(scope, iElement, iAttrs, controller) {
            iElement.bind("click", function(e) {
                e.stopPropagation();
                e.preventDefault();
                controller.openModal();
            });
        },
        controllerAs: "inviteToRegisterCtrl",
        controller: function($scope) {
            var _this = this;

            this.openModal = function() {
                if (_this.customerId) {
                    inviteToRegister(_this.customerId);
                }
            };

            function inviteToRegister(customerId) {
                InviteToRegisterService.get(customerId).then(function(response) {
                    EmailInputModalService.inputEmail(
                        gettextCatalog.getString("Invite to register"),
                        gettextCatalog.getString("customer-to-invite@email.com"),
                        response.data['email']
                    )
                    .then(function onSuccess(email) {
                        InviteToRegisterService.invite(customerId, email)
                        .then(function onSuccess() {
                            var successMessage = gettextCatalog.getString(
                                "The invitation to register was successfully sent at {{email}}.",
                                {email: email}
                            );
                            FlashBag.success(successMessage, true);
                            UserService.refreshCurrentUser();
                        }, function onError(response) {
                            FlashBag.apiError(response);
                        });
                    });
                });
            }

            if (this.initOrderConfirmationWatch) {
                var unregister = $rootScope.$on("doInviteToRegister", function(event, customerId) {
                    inviteToRegister(customerId);
                });

                $scope.$on("$destroy", function() {
                    unregister();
                });
            }
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./customer/app-core/invite-to-register/invite-to-register.directive.js
// module id = 859
// module chunks = 0